import { ReturnButton } from "_components";
import { AlertCreateForm } from ".";

export { AlertsAddEdit };

function AlertsAddEdit() {
    return(
        <div>
            <div className='ml-10 pl-12'>
                <ReturnButton /> 
            </div>          
            <div className="p-12 col-span-3 h-full">                    
                <AlertCreateForm />
            </div>
        </div>
    )
} 